var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.501 26.5392C18.501 25.7112 19.173 25.0272 20.001 25.0272C20.829 25.0272 21.501 25.6892 21.501 26.5172V26.5392C21.501 27.3672 20.829 28.0392 20.001 28.0392C19.173 28.0392 18.501 27.3672 18.501 26.5392Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59168 34.8358H34.5557C36.8497 34.7158 38.6137 32.7618 38.4957 30.4678C38.4697 30.0038 38.3697 29.5458 38.1937 29.1178L23.6397 3.6458C22.5277 1.6358 19.9977 0.907801 17.9877 2.0218C17.3037 2.3978 16.7397 2.9618 16.3617 3.6458L1.80768 29.1178C0.94368 31.2458 1.96768 33.6698 4.09368 34.5358C4.52568 34.7098 4.98168 34.8098 5.44568 34.8358",
    stroke: "#252525",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 20.7922V14.5922",
    stroke: "#252525",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.69c911927a6b3941731db7651c34be37.svg";
export { ForwardRef as ReactComponent };